<div class="modal-content p-4">
  <div class="col-12 custom-box p-5">
    <div class="row d-flex align-center justify-content-between">
      <h3 class="modal-title">Termo Política de Privacidade.</h3>
      <a  (click)="closeModal()" class="closebtn">x</a>
    </div>
    <div class="row mt-2">
      <p [innerHtml]="textoTermo"></p>
    </div>
    <div class="row mt-2 d-flex justify-content-center">
      <button class="btn" (click)="downloadPdf(model[0].arquivoBase64)">Baixar Termo Política de privacidade.</button>
    </div>
  </div>
</div>
